import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import MetricCard from "./MetricCard";

// Define types
interface Metric {
  label: string;
  value: number;
  value1: number;
  unit?: string;
  color: string;
  displayName: string;
  substanceKey: string;
  count: string;
  isoIndex: string;
  icon?: string;

}

interface MetricsSectionProps {
  title: string;
  detectionDetailPage:(data:any) => void
  metrics: Metric[];
}

const MetricsSection: React.FC<MetricsSectionProps> = ({ title, metrics,detectionDetailPage }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box sx={{ mb: 3, p: 2, bgcolor: "#fff", borderRadius: 2, boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.05) !important" }}>
      <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: "bold" }}>
        {title}
      </Typography>
      <Box sx={{ display: "-webkit-box", flexWrap: "wrap", gap: 2, justifyContent: isMobile ? "center" : "flex-start" }}>
        {metrics.map((metric, index) => (
          <MetricCard key={index} detectionDetailPage={detectionDetailPage} metric={metric} />
        ))}
      </Box>
    </Box>
  );
};

export default MetricsSection;
